@if ((invoiceView$ | async) === invoiceViewType.overview || invoiceViewDataNotAvailableYet) {
  <app-invoice-overview></app-invoice-overview>
}

@if ((invoiceView$ | async) === invoiceViewType.detailedOverview) {
  <app-invoice-detailed-overview></app-invoice-detailed-overview>
}

@if ((invoiceView$ | async) === invoiceViewType.totals) {
  <app-invoice-totals></app-invoice-totals>
}
